import { useAccount, useBill, useDeliveryMethods } from '@melio/platform-api';
import { useEffect } from 'react';

export const useTerribleHacks = (billId?: string) => {
  const { data: bill } = useBill({ id: billId });
  const { create, data: deliveryMethods } = useDeliveryMethods({ vendorId: bill?.vendorId });
  const { update: updateAccount, data: currentAccount } = useAccount({ id: 'me' });

  useEffect(() => {
    if (deliveryMethods?.length === 0) {
      void create({
        type: 'bank-account',
        details: {
          accountNumber: Math.round(Math.random() * 1000000000000).toString(),
          routingNumber: '123123123',
          accountType: 'checking',
          isBlocked: false,
          verifiedStatus: 'micro-deposit-verified',
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryMethods?.length ?? -1]);

  useEffect(() => {
    if (currentAccount) {
      const address = {
        line1: '22 Degroat Rd',
        city: 'Sandyston',
        state: 'NJ',
        postalCode: '07827',
        line2: '',
      };

      void updateAccount({
        company: {
          phoneNumber: '1231231234',
          address,
          taxInfo: {
            identifier: '420285678',
            type: 'ITIN',
          },
          legalAddress: address,
          industry: {
            name: 'Software',
            naicsCode: 541511,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccount?.id]);
};

export const getFakeAddressData = () => ({
  city: ' ',
  line1: ' ',
  state: 'NY',
});
